import { Injectable } from '@angular/core';
import { Position, PositionCreationMode } from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class DashboardHookService {
  constructor() {}

  findOpenPosition(positions: Position[]): Position {
    console.warn('DashboardHookService.findOpenPosition not implemented');
    return;
  }

  findCreationMode(positions: Position[]): PositionCreationMode {
    console.warn('DashboardHookService.findCreationMode not implemented');
    return;
  }

  isActionRevoked(positions: Position[]): boolean {
    console.warn('DashboardHookService.isActionRevoked not implemented');
    return false;
  }
}
